import { Get, Put } from "services";
import { ApiPath } from "paths";

export const searchPreAuthTransaction = async (body) => {
  const res = await Get(`${ApiPath.SEARCH_PRE_AUTH_TRANSACTION_LIST(body.venueId)}`, body);
  return res;
};

export const updatePreAuthTransactionStatus = async ({transactionId, body}) => {
  return await Put(`inventory/pre-auth-transaction/${transactionId}/status`, body);
};
